import { useState, useCallback } from "react";
import { fetchResponseAdapter } from "../../../../../adapters/fetchAdapter";
import useCallApiAndLoad from "../../../../../hooks/useCallApiAndLoad";
import { getInvestorByProjects } from "../../../services/devsServices";
import { useDispatch, useSelector } from "react-redux";
import { unsetAuth, getAuthToken } from "../../../../../helpers/authHelper";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../../../../../redux/store";
import { InvestsUser } from "../../../../../models/presales";
import { logoutAction } from "../../../../../redux/features/auth";

export const useDetailProjectInvestors = () => {
    const { country } = useSelector((store: AppStore) => store.country);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [investors, setInvestors] = useState<InvestsUser[]>([]);
    const [investorsLoading, setInvestorsLoading] = useState(false);
    const [lastId, setLastId] = useState<string | number | null>(null);
    const { callEndpoint } = useCallApiAndLoad();

    const user = useSelector((store: AppStore) => store.auth);
    const token = getAuthToken(user);

    const getDataInvestor = useCallback(async (id: string | number) => {
        // Si ya hay datos y el id es igual al anterior, no consultar
        if (lastId === id && investors.length > 0) return;
        if (investorsLoading) return;
        setInvestorsLoading(true);
        setLastId(id);
        try {
            const { status, data } = await callEndpoint(getInvestorByProjects(token, id as string));
            if (status === 401) {
                setInvestorsLoading(false);
                dispatch(logoutAction({}));
                unsetAuth();
                navigate(`/app/${country}/auth/desarrolladoras/login`);
            }
            if (status === 200) {
                const response = fetchResponseAdapter(data);
                setInvestorsLoading(false);
                setInvestors(response.data);
            }
        } catch (error) {
            setInvestorsLoading(false);
            console.log(error);
        }
    }, [investorsLoading, callEndpoint, token, dispatch, JSON.stringify(country), navigate, lastId, investors.length]);

    return { investors, investorsLoading, getDataInvestor };
};